import React from 'react';

import { useNavigate } from 'react-router-dom';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuGroup,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { Dialog, DialogTrigger } from '@/components/ui/dialog';

import ReferralDialog from '@/components/referral/ReferralDialog';

import { useSelector } from 'react-redux';

import { Button } from '@/components/ui/button';

import UserAvatar from '@/components/webchat/teams/UserAvatar';
import LayoutSwitcher from '@/components/sidebar/LayoutSwitcher';

export const NavDropdownMenu = ({ handleLogout }) => {
	const navigate = useNavigate();

	const auth = useSelector((state) => state.auth);

	const { user } = auth;

	const goToSettings = () => {
		navigate('/settings');
	};

	return (
		<DropdownMenu>
			<Dialog>
				<DropdownMenuTrigger asChild>
					<Button
						variant="ghost"
						className="relative h-7 w-7 rounded-full m-1"
					>
						<UserAvatar
							showName={false}
							user={user}
							avatarWidth="30px"
							avatarHeight="30px"
						/>
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent className="w-56" align="end" forceMount>
					<DropdownMenuLabel className="font-normal">
						<div className="flex flex-col space-y-1">
							<p className="text-sm font-medium leading-none">
								{user.name}
							</p>
							<p className="text-xs leading-none text-muted-foreground">
								{user.username}
							</p>
						</div>
					</DropdownMenuLabel>
					<DropdownMenuSeparator />
					<DropdownMenuGroup>
						<DropdownMenuItem onClick={goToSettings}>
							Settings
						</DropdownMenuItem>
						<DropdownMenuItem onClick={() => navigate('/legal')}>
							Terms &amp; policies
						</DropdownMenuItem>
						{!auth.reseller && (
							<>
								<DropdownMenuItem
									onClick={() => window.Intercom('show')}
								>
									Get support
								</DropdownMenuItem>
								<DialogTrigger asChild>
									<DropdownMenuItem>
										<div className="flex flex-col space-y-1">
											<p>Refer us</p>
											<p className="text-xs leading-none text-muted-foreground">
												get a free month
											</p>
										</div>
									</DropdownMenuItem>
								</DialogTrigger>
							</>
						)}
						<DropdownMenuItem>
							<LayoutSwitcher />
						</DropdownMenuItem>
					</DropdownMenuGroup>
					<DropdownMenuSeparator />
					<DropdownMenuItem onClick={handleLogout}>
						Log out
					</DropdownMenuItem>
				</DropdownMenuContent>

				<ReferralDialog />
			</Dialog>
		</DropdownMenu>
	);
};
